// extracted by mini-css-extract-plugin
export default {"card":"ErrorBoundary_card__5YCXV","title":"ErrorBoundary_title__MwGj0","header":"ErrorBoundary_header__N6s1J","icon":"ErrorBoundary_icon__4rfMJ"};